import type { InputHTMLAttributes } from 'react';
import { cn } from '../../utils/cn/cn';
import { Notification } from '../Notification/Notification';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  errorMessage?: string;
  ref?: React.Ref<HTMLInputElement>;
}

const Checkbox = ({
  error,
  errorMessage,
  checked,
  disabled,
  className,
  children,
  ref,
  ...props
}: CheckboxProps) => (
  <>
    <div className="flex items-center">
      <div className="relative flex h-4 w-4 items-center">
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          className={cn(
            'peer border-color-grey-dark focus-visible:standard-focus-outline m-1 h-2 w-2 shrink-0 appearance-none rounded-sm border disabled:opacity-35',
            error && 'border-color-error checkbox-error',
            className,
          )}
          {...props}
        />
        <span
          className={`pointer-events-none absolute inset-0 flex h-4 w-4 items-center justify-center opacity-0 peer-checked:opacity-100 ${disabled ? 'text-color-grey' : ''}`}
          aria-hidden="true"
        >
          <span className="icon-emp-checkmark h-2 w-2" />
        </span>
      </div>
      {children && <div className={disabled ? 'opacity-35' : ''}>{children}</div>}
    </div>
    {error && errorMessage && (
      <Notification severity="error" variant="feedback" className="mt-0.5">
        {errorMessage}
      </Notification>
    )}
  </>
);

export { Checkbox };
